import { render, staticRenderFns } from "./ProjectTasks.vue?vue&type=template&id=63762f0e&scoped=true"
import script from "./ProjectTasks.vue?vue&type=script&lang=js"
export * from "./ProjectTasks.vue?vue&type=script&lang=js"
import style0 from "./ProjectTasks.vue?vue&type=style&index=0&id=63762f0e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63762f0e",
  null
  
)

export default component.exports